import { Fragment, ReactElement, useMemo } from 'react';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import CardCollapse from './card-collapse';
import { DisabledCancellationAireCardMenu } from 'shell/view-models/disabled-menu';
import { CancellationAireAuthorizations } from 'shell/authorizations/cancellations';

interface NestedItemCancellationProps {
  link: string;
  onSubItemClick?: () => void;
}

const NestedItemsCancellation = ({
  link,
  onSubItemClick,
}: NestedItemCancellationProps): ReactElement => {
  const actions = useActionAuthorization({
    perditaCittadinanza: CancellationAireAuthorizations,
    irreperibilitaPresunta: CancellationAireAuthorizations,
  });

  const visibilityCard = useMemo(() => {
    return !actions.perditaCittadinanza && !actions.irreperibilitaPresunta;
  }, [actions]);

  return (
    <Fragment>
      {visibilityCard ? undefined : (
        <CardCollapse
          link={link}
          onSubItemClick={onSubItemClick}
          active={
            {
              ...(actions || {}),
            } as DisabledCancellationAireCardMenu
          }
        />
      )}
    </Fragment>
  );
};

NestedItemsCancellation.displayName = 'nested Items cancellation component';

export default NestedItemsCancellation;
